const initialState = {
  flavorsList: [],
  flavorsDataList: [],
  isFetchingFlavors: false,
  isAddingColour: false,
};

const ColourReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_FLAVORS_GET_DATA":
      return { ...state, isFetchingFlavors: true };
    case "SUCCESS_FLAVORS_GET_DATA":
      return { ...state, flavorsDataList: action.payload.data, isFetchingFlavors: false };
    case "ERROR_FLAVORS_GET_DATA":
      return { ...state };


    case "REQUEST_ADD_COLOUR":
      return { ...state, isAddingColour: true };
    case "SUCCESS_ADD_COLOUR":
      return { ...state, flavorsList: action.payload, isAddingColour: false };
    case "ERROR_ADD_COLOUR":
      return { ...state, isAddingColour: false };

    default:
      return state;
  }
};
export default ColourReducer;
